export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export const statusToneToMantineColor: Record<StatusTone, string> = {
  success: 'green',
  warning: 'yellow',
  danger: 'red',
  info: 'blue',
  neutral: 'gray',
};
